export default __webpack_public_path__ + "static/media/Khemit.2d481bc3.jpg";